import React from 'react';
export function Footer() {
  return <footer className="py-16 px-6 bg-pond-dark border-t border-pond-blue/10" data-id="element-74">
      <div className="max-w-6xl mx-auto" data-id="element-75">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-76">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-77">
            <div className="w-10 h-10 rounded-xl overflow-hidden" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/6X5Ni2Q9nDpaafqtoDsFw2/Rectangle_2404.png" alt="Pond App Icon" className="w-full h-full object-cover" data-id="element-79" />
            </div>
            <span className="text-2xl font-serif text-pond-cream" data-id="element-80">Pond</span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm text-pond-cream-muted" data-id="element-81">
            <a href="https://go.pixo.co/pond-privacy" target="_blank" rel="noopener noreferrer" className="hover:text-pond-blue transition-colors" data-id="element-82">
              Privacy
            </a>
            <a href="https://go.pixo.co/pond-terms" target="_blank" rel="noopener noreferrer" className="hover:text-pond-blue transition-colors" data-id="element-83">
              Terms
            </a>
            <a href="mailto:support@pixo.co" className="hover:text-pond-blue transition-colors" data-id="element-84">
              Support
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-pond-blue/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-pond-cream-muted" data-id="element-85">
          <p data-id="element-86">© 2026 Pond App by PIXO Inc. All rights reserved.</p>
          <p className="text-pond-cream-muted/60" data-id="element-87">Made with intention 🪷</p>
        </div>
      </div>
    </footer>;
}